import { useEffect } from 'react';

import { VIRAL_LOOPS_LOADER_ID, VIRAL_LOOPS_SCRIPT_SRC } from './constants';

import type { ReactElement } from 'react';

type Props = {
  campaignId: string;
};

export const ReferralWidget = ({ campaignId }: Props): ReactElement => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('id', VIRAL_LOOPS_LOADER_ID);
    script.setAttribute('src', VIRAL_LOOPS_SCRIPT_SRC);
    script.setAttribute('data-campaign-id', campaignId);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(VIRAL_LOOPS_LOADER_ID);
      scriptToRemove?.remove();
    };
  }, [campaignId]);

  return (
    <div data-vl-campaign-id={campaignId} data-vl-container="sharing-stage">
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore  */}
      <form-widget ucid={campaignId}></form-widget>
    </div>
  );
};
